export default __webpack_public_path__ + "static/media/img-0619-monaco-half-face.309c15d8.png";